import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Countdown, Overlay } from '@/components';
import classnames from 'classnames';
import { memo, useState } from 'react';
import styles from './index.module.less';
export const StatusOverlay = memo(({ name, start, end, ...props }) => {
    const [started, setStarted] = useState(false);
    const showEnded = end && end < Date.now();
    const isOnSale = started && !showEnded;
    if (!start || !end || isOnSale)
        return null;
    return (_jsx(Overlay, { ...props, className: classnames(styles.container, props.className), children: showEnded ? (_jsx("div", { className: styles.box, children: _jsx("h2", { className: styles.title, children: "Ended" }) })) : (_jsxs("div", { className: styles.box, children: [_jsx("h2", { className: styles.title, children: name }), _jsx("p", { className: styles.subtitle, children: "start sale in" }), _jsx(Countdown, { className: styles.countdown, end: start, onEnded: () => setStarted(true) })] })) }));
});
